import {
  Button,
  Menu,
  MoreIcon,
  PlayIcon,
  StopIcon,
  Switch,
  TransferIcon,
  UnlockIcon,
} from "melco-ui";
import { Dropdown } from "antd";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { isEmpty } from "lodash";
import { MelcoModelsUser, useConfirm } from "melco-shared-logic";
import { useUnlockUser } from "../../hooks/users/useUnlockUser";
import { useEnableUser } from "../../hooks/users/useEnableUser";
import { useDisableUser } from "../../hooks/users/useDisableUser";
import { useRolesContext } from "../../hooks/roles/useRolesContext";
import styled from "styled-components";
import { useState } from "react";
import { SwitchPaymentModeDrawer } from "./drawer/SwitchPaymentModeDrawer";

type UserDetailMoreActionButtonProps = {
  user: MelcoModelsUser;
};


const MenuItemSwitchPaymentMode = styled(Menu.Item)`
  .ant-menu-item-icon {
    display: flex;
    align-items: center;
  }

  .ant-switch.ant-switch-small {
    width: 17px;
    height: 11px;
    line-height: 11px;
  }

  .ant-switch.ant-switch-small .ant-switch-handle {
    width: 7px;
    height: 7px;
    top: 2px;
    left: 2px;
  }

  .ant-switch.ant-switch-small.ant-switch-checked .ant-switch-handle {
    left: calc(100% - 9px);
  }
`;

export const UserDetailMoreActionButton: React.FC<
  UserDetailMoreActionButtonProps
> = ({ user }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { roles } = useRolesContext();
  const [openPaymentModeModal, setOpenPaymentModeModal] = useState(false);

  const unlockUser = useUnlockUser();
  const enableUser = useEnableUser(user?.id ?? undefined);
  const disableUser = useDisableUser(user?.id ?? undefined);

  //const shouldShowWarning = useShouldShowWarning();

  const confirmUnlockUser = useConfirm(
    async () => {
      //TODO: Handle case if user.id doesnt exist
      if (user.id) {
        const successfullyUnlock = await unlockUser(user);

        // redirect to list view in case the user was unlocked successfully
        if (!isEmpty(successfullyUnlock)) {
          navigate(`/users`);
        }
      }
    },
    {
      translationPrefix: "users.actions.unlock",
      translationOptions: {
        count: 1,
      },
    }
  );

  const confirmEnableUser = useConfirm(
    async () => {
      //TODO: Handle case if user.id doesnt exist
      if (user.id) {
        const enableUserResponse = await enableUser();

        // redirect to list view in case the user was unlocked successfully
        if (enableUserResponse.success) {
          navigate(`/users`);
        }
      }
    },
    {
      translationPrefix: "users.actions.enable",
      translationOptions: {
        count: 1,
      },
    }
  );

  const confirmDisableUser = useConfirm(
    async () => {
      //TODO: Handle case if user.id doesnt exist
      if (user.id) {
        const disableUserResponse = await disableUser();

        // redirect to list view in case the user was unlocked successfully
        if (disableUserResponse.success) {
          navigate(`/users`);
        }
      }
    },
    {
      translationPrefix: "users.actions.disable",
      translationOptions: {
        count: 1,
      },
    }
  );

  const MoreActions = (
    <Menu>
      {roles.USERS_UNLOCK && user && (
        <Menu.Item
          key="more-actions-unlock"
          danger
          onClick={() => {
            confirmUnlockUser();
          }}
          icon={<UnlockIcon />}
        >
          {/* <DeleteIcon /> {t("color_collections.actions.delete.button")} */}
          {t("users.actions.unlock.button")}
        </Menu.Item>
      )}
      {/**
       * TO Do: there is no is_disbale coming in response
       * when it will be there we will show only one enable or disable
       */}
      {roles.USERS_DISABLE && user && user.is_disabled && (
        <Menu.Item
          key="more-actions-enable"
          icon={<PlayIcon />}
          onClick={() => {
            confirmEnableUser();
          }}
        >
          {t("users.actions.enable.button")}
        </Menu.Item>
      )}
      {roles.USERS_DISABLE && user && !user.is_disabled && (
        <Menu.Item
          key="more-actions-disable"
          icon={<StopIcon />}
          onClick={() => {
            confirmDisableUser();
          }}
        >
          {t("users.actions.disable.button")}
        </Menu.Item>
      )}

      {
        user && (
          <MenuItemSwitchPaymentMode
            icon={<TransferIcon />}
            // icon={<Switch
            //   size="small"
            //   checked={false}


            // />}
            onClick={() => {
              setOpenPaymentModeModal(true);
            }}
            key="more-actions-switch-payment-mode">

            <span>{t("users.actions.switch_payment_mode.button")}</span>
          </MenuItemSwitchPaymentMode>
        )}

    </Menu>
  );

  return (
    <>
      <Dropdown
        overlay={MoreActions}
        trigger={["click"]}
        placement="bottomRight"
        arrow
      >
        <Button
          key="user-detail-more-actions"
          icon={<MoreIcon />}
          data-cy-id="user-detail-more-actions"
        />
      </Dropdown>
      {
        openPaymentModeModal && (
          <div>
            <SwitchPaymentModeDrawer
              isDrawerOpen={openPaymentModeModal}
              setDrawerOpen={setOpenPaymentModeModal}
              user={user}
            />
          </div>
        )
      }
    </>);
};
